import {Location} from "../../types/Location";
import useCancelTokenSource from "../../hooks/useCancelTokenSource";
import TownAPIs from "../../APIs/TownAPIs";
import SearchBar from "./SearchBar";
import React, {useCallback} from "react";
import {REQUEST_CANCELED} from "../../helpers/Message";

interface LocationSearchBarProps {
    disabled: boolean,
    disableSearchButton: (v: boolean) => void,
    setLocation: (l: Location | null) => void
}

function LocationSearchBar({disabled, disableSearchButton, setLocation} : LocationSearchBarProps) {
    const { createSource, cancelPreviousRequest } = useCancelTokenSource({
        cancelMessage: REQUEST_CANCELED
    });

    const handleSelect = (location: Location) => {
        disableSearchButton(false);
        setLocation(location);
    }

    const fetchData = useCallback(async (query: string): Promise<Location[]> => {
        cancelPreviousRequest(REQUEST_CANCELED);

        if (query.length >= 2) {
            const source = createSource();
            return TownAPIs.getLocations({search: query}, source);
        }

        return [];
    }, [cancelPreviousRequest, createSource]);

    const format = useCallback((location: Location) => ({ value: location, label: location.label }), []);


    return (
        <SearchBar<Location>
            placeholder="Ville, département ou code postal"
            name="ville"
            disabled={disabled}
            onSelect={handleSelect}
            onChange={() => disableSearchButton(true)}
            optionsProps={{
                format: format,
                fetchDataOnChange: fetchData
            }}
        />
    )
}

export default LocationSearchBar;
